import { APPOINTMENT_API_BASE_URL } from 'config';
import { SharedEnaraNodeClient } from 'node-api/common/SharedEnaraNodeClient';
import {
  MeetingConnectionData,
  NotificationMethod,
  SendMeetingConnectionLinkResponse,
} from './appointments.types';

export class AppointmentsClient extends SharedEnaraNodeClient {
  public async getVideoMeetingData(
    memberUuid: string,
    providerUuid: string
  ): Promise<MeetingConnectionData> {
    const payload = {
      memberUuid,
      providerUuid,
    };

    try {
      const response = await this.axiosClient.post<MeetingConnectionData>('/meetings', payload);
      const { data } = response;
      if (!data) {
        throw new Error('Failed to get video token from appointment-api');
      }

      return data;
    } catch (error) {
      console.error('Error in getVideoMeetingData:', error);
      throw error;
    }
  }

  public async getVideoMeetingDataWithAppointmentId(
    coreScheduleId: number
  ): Promise<MeetingConnectionData> {
    try {
      const url = `/meetings/core-schedulings/${coreScheduleId}/meeting`;
      const response = await this.axiosClient.post<MeetingConnectionData>(url);
      const { data } = response;
      if (!data) {
        throw new Error('Failed to get video token from appointment-api');
      }

      return data;
    } catch (error) {
      console.error('Error in getVideoMeetingDataWithAppointmentId:', error);
      throw error;
    }
  }

  public async sendMeetingConnectionLink(
    meetingData: Partial<{ coreAppointmentId: number; memberUuid: string; providerUuid: string }>,
    methods: NotificationMethod[]
  ): Promise<{ [participantUuid: string]: { [method: string]: boolean } } | null> {
    if (!methods?.length) {
      throw new Error(`The list of methods can't be an empty array`);
    }

    try {
      const response = await this.axiosClient.post<SendMeetingConnectionLinkResponse>(
        '/meetings/connection-link',
        {
          ...meetingData,
          methods,
        }
      );
      return response.data.participants.reduce(
        (acc, current) => ({
          ...acc,
          [current.participantUuid]: current.methods.reduce(
            (methodsAcc, { method, success }) => ({ ...methodsAcc, [method]: success }),
            {}
          ),
        }),
        {}
      );
    } catch (error) {
      return null;
    }
  }
}

export const appointmentsClient = new AppointmentsClient(APPOINTMENT_API_BASE_URL);
